(function () {
  const money = (cents) => {
    // Basic USD formatting; uses Shopify's theme formatting if you later enhance it.
    const dollars = (Math.max(0, cents) / 100).toFixed(2);
    return `$${dollars}`;
  };

  function updateBars(cart) {
    document.querySelectorAll(".rzn-shipbar").forEach((bar) => {
      const threshold = parseInt(bar.getAttribute("data-threshold"), 10) || 9900;
      const total = cart.total_price || 0;
      const remaining = threshold - total;

      const msg = bar.querySelector(".rzn-shipbar__msg");
      const fill = bar.querySelector(".rzn-shipbar__fill");
      const track = bar.querySelector(".rzn-shipbar__track");

      const pct = Math.max(0, Math.min(100, (total / threshold) * 100));
      if (fill) fill.style.width = pct + "%";

      if (track) {
        track.setAttribute("aria-valuemax", String(threshold));
        track.setAttribute("aria-valuenow", String(total));
      }

      if (msg) {
        if (remaining > 0) {
          msg.innerHTML = `Add <strong>${money(remaining)}</strong> more to unlock <strong>FREE SHIPPING $99+</strong>`;
        } else {
          msg.innerHTML = `<strong>You’ve unlocked FREE SHIPPING $99+</strong>`;
        }
      }
    });
  }

  async function fetchCartAndUpdate() {
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      if (!res.ok) return;
      const cart = await res.json();
      updateBars(cart);
    } catch (_) {}
  }

  // Initial update
  fetchCartAndUpdate();

  // Update after add-to-cart (Shopify themes commonly use /cart/add.js)
  const _fetch = window.fetch;
  window.fetch = async function (...args) {
    const resp = await _fetch.apply(this, args);
    try {
      const url = typeof args[0] === "string" ? args[0] : (args[0] && args[0].url) || "";
      if (url.includes("/cart/add") || url.includes("/cart/change") || url.includes("/cart/update")) {
        // wait a tick for theme to re-render drawer
        setTimeout(fetchCartAndUpdate, 250);
      }
    } catch (_) {}
    return resp;
  };

  // Also update when drawer opens (covers some theme behaviors)
  document.addEventListener("click", (e) => {
    const el = e.target.closest('a[href*="/cart"], button[name="checkout"], button, a');
    if (el) setTimeout(fetchCartAndUpdate, 400);
  });
})();